export default __webpack_public_path__ + "static/media/cartest.7b6f8696.svg";